export enum PRODUCT_TYPE {
  BNA = '1'
}
